<template>
  <div class="login-wrap">
    <div class="login-box">
      <h2>系统登录</h2>
      <el-input v-model="username" placeholder="请输入用户名"></el-input>
      <el-input v-model="password" placeholder="请输入密码" type="password" show-password></el-input>
      <el-button type="primary" @click="doLogin">立即登录</el-button>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/store/user'
export default {
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    doLogin() {
      if (!this.username || !this.password) {
        this.$message.warning('请输入账号密码')
        return
      }
      // 存入Pinia
      const userStore = useUserStore()
      userStore.setUser({
        username: this.username,
        token: 'admin_666888'
      })
      this.$message.success('登录成功')
      // 跳转到用户列表
      this.$router.push('/home/userList')
    }
  }
}
</script>

<style scoped>
.login-wrap {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-box {
  width: 350px;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
}
.el-input {
  margin-bottom: 20px;
}
.el-button {
  width: 100%;
}
</style>